
<style scoped>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.detail-row {
  display: flex;
  padding: 0 20px;
}
.detail-row .item {
  display: flex;
  flex: 1;
  align-items: center;
}
.detail-row .item .tittle {
  width: 110px;
  text-align: left;
}
.detail-row .item .content {
  width: 500px;
  text-align: left;
}
.detail-row .pdf-container img {
  width: 40px;
  height: 40px;
}
.detail-row .item .pdf-container {
  width: auto;
  text-align: center;
}
/deep/ .el-upload-list {
    text-align: left;
    max-height: 150px;
    overflow-y: auto;
}
  .opreateIcon {
    display: inline-block;
    width: 80px;
    text-align: left;
  }

  .opreateIcon i {
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    padding: 2px 6px;
    margin-left: 4px;
  }

  .opreateIcon i:hover {
    color: #4fa1a4;
  }
</style>
<style >
.freelist .el-form-item__content {
  margin-left: 0 !important;
}
.freelist .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}
.freelist .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}
.freelist .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
.freelist .el-image {
  visibility: hidden;
}
.freelist .file1 .el-upload--picture-card {
  display: none;
}
.el-image-viewer__wrapper {
  z-index: 99999 !important;
}
</style>
<template>
  <div class="content freelist">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="8"
          ><div class="search-area-div">公司名称：</div>
           <el-select v-model="page.tenantGuid" placeholder="请选择公司名称" filterable class="ipt-sty">
             <el-option 
              v-for="item in tenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
            </el-option>
          </el-select>
        </el-col> 
        <el-col :span="8">
          <div class="search-area-div">费用月份：</div>
          <el-date-picker
            class="ipt-sty"
            v-model="page.accountMonth"
            type="month"
            align="left"
            unlink-panels
            placeholder="请选择支付月份"
            range-separator="-"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyyMM"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="8">
          <div class="search-area-div">发送时间：</div>
          <el-date-picker
            v-model="timeLists"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
             class="ipt-sty"
            end-placeholder="结束时间">
          </el-date-picker>
        </el-col>
      </el-row>

      <div style="padding: 20px 20px 0 0; text-align: right">
        <el-button size="medium" type="info" @click="getSalaryAllList(true)">搜索</el-button>
        <el-button size="medium" type="danger" @click="emptySearch">清空</el-button>
      </div>
    </div>

    <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="importPayRollData()">上传工资条</el-button>
    </div>
    <div class="back-color-fff p16">
      <el-table :data="tableData" border style="width: 100%;" v-loading="tableLoading">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column label="费用名称" header-align="center" align="center">
          <template slot-scope="scope">{{getFreeName(scope.row,1) }}</template>
        </el-table-column>

        <el-table-column prop="tenantName" label="企业名称" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.tenantName }}</template>
        </el-table-column>

        <el-table-column prop="tenantName" label="已发送" :render-header="renderHeaderI" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.sendCount==null?'-':scope.row.sendCount }}/{{scope.row.detailCount==null?'-':scope.row.detailCount }}</template>
        </el-table-column>

        <el-table-column prop="tenantName" label="已查看" :render-header="renderHeaderII" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.viewCount==null?'-':scope.row.viewCount}}/{{scope.row.sendCount==null?'-':scope.row.sendCount }}</template>
        </el-table-column>

     
        <el-table-column prop="importTime" label="上传时间" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.importTime | getTime }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="300">
          <template slot-scope="scope">
            <a class="txt-color" @click="sendSalary(scope.row)">查看发送 | </a>
            <a class="txt-color" @click="editField(scope.row)"> 设置字段｜ </a>
            <a class="txt-color" @click="editContract(scope.row)"> 修改名称｜ </a>
            <a class="txt-color-red" @click="getDeleteData(scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>

    <el-dialog :title="textTitle" :visible.sync="dialogVisible" width="620px">
       <el-form label-width="140px" :label-position="right" class="demo-ruleForm">
        <el-form-item>
        <span slot="label" style="color: red">*</span>
        <span slot="label">费用名称：</span>
        <div style="display:flex;">
          <span style="margin-right:16px">{{getFreeName(form,0)}}</span>
          <el-input
            v-model="form.title"
            placeholder="输入自定义名称，最多10个字"
            style="width:270px"
          >
          </el-input>
        </div>
      </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">温馨提示：</span>
          <el-input
            style="width:400px;margin-left: -40px;"
            v-model="form.note"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="dialogVisible = false">取 消</el-button>
        <el-button
          size="medium"
          type="info"
          @click="updateReqVersion"
          v-loading.fullscreen.lock="fullscreenLoading"
          >修 改</el-button
        >
      </span>
    </el-dialog>

     <!-- 表头设置 -->
    <el-dialog title="设置字段显示规则" :visible.sync="showSetHead" width="620px" class="setHeadClass" :close-on-click-modal="false" >
      <div class="setHead">
        <div class="right">
          <el-table  ref="fieldTable"  :data="selectedData" height="500px" @selection-change="handleSelectionChange" >
            <el-table-column  type="selection" width="55">
            </el-table-column>
            <el-table-column prop="name" label="字段名称">
            </el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <div class="opreateIcon">
                  <i v-if="scope.$index+1 != selectedData.length" class="el-icon-sort-down" @click="sortDownField(scope.row,scope.$index)"></i>
                  <i v-if="scope.$index !=0" class="el-icon-sort-up" @click="sortUpField(scope.row,scope.$index)"></i>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showSetHead = false" size="small">取 消</el-button>
        <el-button type="info" @click="updateFieldVisible" size="small">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 结束 -->
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
  },
  data() {
    return {
      showSetHead:false,
      selectedData:[],
      fieldSelected:[],

      giveStatueList: [
        { value: '0', label: '全部' },
        { value: '1', label: '已上传' },
        { value: '2', label: '未上传' },
      ],
      form: {
        accountMonth: null,
        title: null,
        note: null,
        salaryType:null,

      },
     
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        startTime: null,
        endTime: null,
        accountMonth:null,
        tenantGuid: null,
        title:null,
        colInfo:null,
      },
      staffList:[],
      tenantList: [],
      organisationList:[],
      errorInfoList:[],
      timeLists:'',
      srcLists:[],

      
      taskGuid: [],
      srcList: [],
      fullscreenLoading: false,
      textTitle: '新增完税凭证',
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      startEndTime: '',
      payMonth: '',
      payMoney: '',
      note: '',
      payFile: '',

      guid: '',
      tableLoading: false,
      tableData: [],
      height: window.innerHeight - 400,
      right: 'right',
    };
  },
  created() {
    // this.page.giveStatue = this.$route.query.giveStatue; 
    this.getTenantList(); 
    this.getSalaryAllList();
    // this.getTaskList();

  },
  watch: {
    payMonth(newVal) {
      if (!newVal) return;
      var newVal = newVal + '-01';
      var self = this;
      self.api
        .get(
          `/${serverConfig.msConfigureService}/sysparameter/data/get-account-month-full-area?date=` +
            newVal +
            '&tenantGuid=' +
            this.currentCompanyGuid
        )
        .then((resp) => {
          self.startEndTime = resp.data.data.replace(',', '至');
        });
    }
  },
  methods: {
    sendSalary(row){
      this.$router.push({
        path:'payRollDetail',
        query:{
          productGuid:this.$route.query.productGuid,
          detail:JSON.stringify(row)
        }
      })
    },
    editField(row){
      console.log(row);
      this.showSetHead = true;
      this.selectedData = JSON.parse(row.colInfo);
      this.guid = row.guid;
      this.$nextTick(()=>{
        this.selectedData.forEach((item, index) => {
          if (item.isShow) {
            this.$refs.fieldTable.toggleRowSelection(item,index)
          }
        })
      })
    },
    handleSelectionChange(val){
      this.fieldSelected = val;
    },
    //表头设置-向下
    sortDownField(row, index) {
      let orderNumFlag = row.index
      row.index = this.selectedData[index + 1].index
      this.selectedData[index + 1].index = orderNumFlag
      this.selectedData.splice(index, 1)
      this.selectedData.splice(index + 1, 0, row)
    },
    //表头设置-向上
    sortUpField(row, index) {
      let orderNumFlag = row.index
      row.index = this.selectedData[index - 1].index
      this.selectedData[index - 1].index = orderNumFlag
      this.selectedData.splice(index, 1)
      this.selectedData.splice(index - 1, 0, row)
    },
    updateFieldVisible(){
      this.selectedData.forEach((i,j) => {
        i.isShow = false;
        this.fieldSelected.forEach((m,n)=>{
            if(i.guid == m.guid){
              i.isShow = true;
            }
        })
      })
      var req = {
        guid: this.guid,
        colInfo: JSON.stringify(this.selectedData)
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/salary/note/edit-total`, req).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.showSetHead = false;
          this.$message.success('修改成功');
          this.page.pageIndex = 1;
          this.getSalaryAllList(true);
        } else {
          this.$message.error(res.data.msg);
        }
      });

       console.log(this.selectedData)
    },
    getFreeName(detail,type) {
      if(!detail.accountMonth) return;
      let month = detail.accountMonth.substr(0, 4) + '年' + detail.accountMonth.substr(4, 5) + '月';
      let title = detail.title;
      let salaryName = this.getSalaryName(detail.salaryType);
      if(type){
         return month + salaryName + title;
      }else{
         return month + salaryName;
      }
     
    },
    getSalaryName(salaryType) {
      if (salaryType == 1) {
        return '工资条'
      }
      if (salaryType == 2) {
        return '业务费用'
      }
      if (salaryType == 3) {
        return '其他'
      }
    },
    getTenantList() {
      let self = this;
      let query = {
        isService:true,
        tenantGuid:localStorage.guid
      };
      self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.timeLists = [];
      this.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        startTime: '',
        endTime: '',
        accountMonth:'',
        tenantGuid: '',
        title:'',
        colInfo:'',
      };
      this.getSalaryAllList(true);
    },
    importPayRollData() {
      this.$router.push('/importPayRollData')
    },
    editContract(detail) {
      this.textTitle = '修改名称';
      this.form = {
        accountMonth:detail.accountMonth,
        title:detail.title,
        note:detail.note,
        salaryType:detail.salaryType,
        guid:detail.guid
      }
      this.dialogVisible = true;
    },
    getSalaryAllList(flg) {
      var self = this;
      if(flg){
        self.page.pageIndex = 1;
        self.tableData = [];
      } 
      if(self.timeLists != null && self.timeLists.length > 0){
        self.page.startTime = self.$moment(self.timeLists[0]).format('YYYY-MM-DD HH:mm:ss');
        self.page.endTime = self.$moment(self.timeLists[1]).format('YYYY-MM-DD 23:59:59');
      }else{
        self.page.startTime = '';
        self.page.endTime = '';
      }
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/salary/note/get-list-total`,this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getDeleteData(guid) {
      var self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api.postJson(`/${serverConfig.msSalesPerformService}/salary/note/remove-total?guid=${guid}`).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.page.pageIndex = 1;
              self.getSalaryAllList(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    updateReqVersion() {
      var self = this;
      if (!this.form.title) {
        self.$message('请填写自定义名称!');
        return;
      }
       if (!this.form.note) {
        self.$message('请填写温馨提示!');
        return;
      }
      var req = {
        guid: self.form.guid, 
        title:this.form.title,
        note:this.form.note
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/salary/note/edit-total`, req).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('修改成功');
          self.page.pageIndex = 1;
          self.getSalaryAllList(true);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },

    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getSalaryAllList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getSalaryAllList();
    },
    renderHeaderI (h, { column, $index }) {
      return [
        column.label,
        h(
          'el-tooltip',
          {
            props: {
              placement: 'top',
              effect: 'dark',
              //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
            },
          },
          [
            h(
              'div',
              {
                //当前div是为了实现换行，就这换行研究了好久。。。
                slot: 'content',
              },
              [
                "成功发送/计划发送人数（导入的人数）"
              ],
            ),
            h('span', {
              //问号模块
              class: {
                'el-icon-question': true,
              },
            }),
          ],
        ),
      ];
    },
    renderHeaderII (h, { column, $index }) {
      return [
        column.label,
        h(
          'el-tooltip',
          {
            props: {
              placement: 'top',
              effect: 'dark',
              //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
            },
          },
          [
            h(
              'div',
              {
                //当前div是为了实现换行，就这换行研究了好久。。。
                slot: 'content',
              },
              [
                '已读工资明细的人数/成功发送工资条的人数',
              ],
            ),
            h('span', {
              //问号模块
              class: {
                'el-icon-question': true,
              },
            }),
          ],
        ),
      ];
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
</style>